import './AttachFileChatPost.css';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import { PropTypes } from 'prop-types';
import { useMemo } from 'react';
import ImageAttachFile from './ImageAttachFile';
import OtherAttachFile from './OtherAttachFile';
import { getChatPostAttachFiles, separateImageAndOtherFiles } from './AttachFileHandler';

function AttachFileChatPost ({
    detailTicket,
    setOpenPreviewImage,
    setOpenFileOption,
    setOpenOption
}) {
    const chatPostAttachFileList = useMemo(
        () => getChatPostAttachFiles(detailTicket?.attachFiles),
        [detailTicket?.attachFiles]
    );
    
    const { images: imgAttachFileList, others: otherAttachFileList } = useMemo(
        () => separateImageAndOtherFiles(chatPostAttachFileList),
        [chatPostAttachFileList]
    );

    // Don't render if there's no data
    if (Utils.isEmptyArray(imgAttachFileList) && Utils.isEmptyArray(otherAttachFileList)) {
        return null;
    }

    return (
        <div className="attach-file-chat-post-container">
            <p className="attach-file-chat-post-title">
                {I18n.get('IMG_CHATPOST_FIELD')}
            </p>
            {!Utils.isEmptyArray(otherAttachFileList) && (
                <ul className="attach-file-chat-post-list">
                    {
                        otherAttachFileList.map(item => (
                            <li key={item.id} className="attach-file-chat-post-item">
                                <OtherAttachFile
                                    attachData={item}
                                    detailTicket={detailTicket}
                                />
                            </li>
                        ))
                    }
                </ul>
            )}
            <div className="attach-file-chat-post-images">
                {imgAttachFileList.map(item => (
                    <ImageAttachFile
                        key={item.id || item.originId}
                        attachData={item}
                        detailTicket={detailTicket}
                        setOpenPreviewImage={setOpenPreviewImage}
                        setOpenFileOption={setOpenFileOption}
                        setOpenOption={setOpenOption}
                    />
                ))}
            </div>
        </div>
    );
};

AttachFileChatPost.propTypes = {
    detailTicket: PropTypes.any,
    fieldListDefaultData: PropTypes.any,
    setOpenPreviewImage: PropTypes.any,
    setOpenFileOption: PropTypes.any,
    setOpenOption: PropTypes.any
};

export default AttachFileChatPost;